import { Link } from 'react-router-dom';
import { parseContent, formatDate } from '../utils/parseContent';
import { ShareButtons } from './ShareButtons';
import './BlogPost.css';

export function BlogPost({ post, isPreview = false }) {
  const { id, title, content, featuredImage, createdAt } = post;

  const formattedDate = formatDate(createdAt);

  return (
    <article className="blog-post">
      {/* Header: Date + Share - now at the top for better visual separation */}
      <header className="blog-post__header">
        <div className="blog-post__date text-sans text-small text-uppercase text-muted">
          {formattedDate}
        </div>
        <ShareButtons postId={id} title={title} />
      </header>

      {/* Divider after header */}
      {isPreview && <hr className="blog-post__header-divider" />}

      {/* Title */}
      {title && (
        <h2 className="blog-post__title">
          {isPreview ? (
            <Link to={`/post/${id}`}>{title}</Link>
          ) : (
            title
          )}
        </h2>
      )}

      {/* Featured Image */}
      {featuredImage && (
        <div className="blog-post__featured-image">
          <img
            src={featuredImage}
            alt={title || 'Featured image'}
            loading="lazy"
          />
        </div>
      )}

      {/* Content */}
      <div
        className="blog-post__content"
        dangerouslySetInnerHTML={{ __html: parseContent(content) }}
      />

      {/* Author attribution */}
      <p className="blog-post__author">Tim Autrey</p>

      {/* Divider between posts */}
      {isPreview && <hr className="blog-post__divider" />}
    </article>
  );
}
